export const useStatamicGlobals = () => {
    const statamic = useStatamic()

    const getGlobal = (req) => statamic(`/globals/${req.handle}`)

    return {
        getGlobal,
    }
}
